<template>
    <console-layout width="100%" max-width="1560">

        <console-title>
            <span>탈퇴회원</span>
        </console-title>
        
        <console-search @search="page=1; search()">
            <v-row align="center">
                <v-col cols="12" sm="6">
                    <v-date-field v-model="filter.withdrawnAt[0]" label="탈퇴일자" persistent-placeholder hide-details />
                </v-col>
                <v-col cols="12" sm="6">
                    <v-date-field v-model="filter.withdrawnAt[1]" label="탈퇴일자" persistent-placeholder hide-details />
                </v-col>
            </v-row>
            <v-row align="center">
                <v-col cols="12" sm="3">
                    <v-select v-model="filter.levelCode" label="회원등급" persistent-placeholder hide-details :items="giftcardLevels" item-text="text" item-value="value"/>
                </v-col>
                <v-col cols="12" sm="3">
                    <v-select v-model="filter.searchKey" label="검색조건" persistent-placeholder hide-details :items="searchKeys" item-text="text" item-value="value" @input="filter.searchValue = null;"/>
                </v-col>
                <v-col cols="12" sm="3">
                    <v-text-field v-model="filter.searchValue" label="검색어" persistent-placeholder hide-details :disabled="!filter.searchKey" @keydown.enter="page=1; search(true)" />
                </v-col>
            </v-row>
        </console-search>

        <console-body>

            <v-layout class="align-end">
                <span class="subtitle-2">검색된 회원수: {{ summary.totalCount.format() }}</span>
                <v-spacer />
                <span>
                    <withdrawal-dialog v-if="$hasScope(['root', 'admin'])" />
                    <v-btn color="white" elevation="1" class="green--text px-2 ml-1" @click="excel">
                        <v-icon class="mr-2">mdi-microsoft-excel</v-icon>엑셀다운로드
                    </v-btn>
                </span>
            </v-layout>
    
            <v-data-table :loading="loading" :items="members" :headers="membersHeaders" hide-default-footer disable-sort class="mt-2 elevation-1">
                <template v-slot:[`header.username`]="{header}">
                    {{ header.text }}
                    <v-btn icon x-small>
                        <v-icon v-if="(filter.sortBy == null || filter.sortBy !== 'username')" @click="sortOptions(`username`, false)">mdi-arrow-up-bold-outline</v-icon>
                        <v-icon v-if="(filter.sortDesc == false && filter.sortBy == 'username')"  @click="sortOptions(`username`, true)">mdi-arrow-up-bold</v-icon>
                        <v-icon v-if="(filter.sortDesc && filter.sortBy == 'username')" @click="sortOptions(null, null)">mdi-arrow-down-bold</v-icon>
                    </v-btn>
                </template>
                <template v-slot:[`header.name`]="{header}">
                    {{ header.text }}
                    <v-btn icon x-small>
                        <v-icon v-if="(filter.sortBy == null || filter.sortBy !== 'name')" @click="sortOptions(`name`, false)">mdi-arrow-up-bold-outline</v-icon>
                        <v-icon v-if="(filter.sortDesc == false && filter.sortBy == 'name')"  @click="sortOptions(`name`, true)">mdi-arrow-up-bold</v-icon>
                        <v-icon v-if="(filter.sortDesc && filter.sortBy == 'name')" @click="sortOptions(null, null)">mdi-arrow-down-bold</v-icon>
                    </v-btn>
                </template>
                <template v-slot:[`header.point`]="{header}">
                    {{ header.text }}
                    <v-btn icon x-small>
                        <v-icon v-if="(filter.sortBy == null || filter.sortBy !== 'point')" @click="sortOptions(`point`, false)">mdi-arrow-up-bold-outline</v-icon>
                        <v-icon v-if="(filter.sortDesc == false && filter.sortBy == 'point')"  @click="sortOptions(`point`, true)">mdi-arrow-up-bold</v-icon>
                        <v-icon v-if="(filter.sortDesc && filter.sortBy == 'point')" @click="sortOptions(null, null)">mdi-arrow-down-bold</v-icon>
                    </v-btn>
                </template>
                <template v-slot:[`header.cash`]="{header}">
                    {{ header.text }}
                    <v-btn icon x-small>
                        <v-icon v-if="(filter.sortBy == null || filter.sortBy !== 'cash')" @click="sortOptions(`cash`, false)">mdi-arrow-up-bold-outline</v-icon>
                        <v-icon v-if="(filter.sortDesc == false && filter.sortBy == 'cash')"  @click="sortOptions(`cash`, true)">mdi-arrow-up-bold</v-icon>
                        <v-icon v-if="(filter.sortDesc && filter.sortBy == 'cash')" @click="sortOptions(null, null)">mdi-arrow-down-bold</v-icon>
                    </v-btn>
                </template>
                <template v-slot:[`header.createdAt`]="{header}">
                    {{ header.text }}
                    <v-btn icon x-small>
                        <v-icon v-if="(filter.sortBy == null || filter.sortBy !== 'createdAt')" @click="sortOptions(`createdAt`, false)">mdi-arrow-up-bold-outline</v-icon>
                        <v-icon v-if="(filter.sortDesc == false && filter.sortBy == 'createdAt')"  @click="sortOptions(`createdAt`, true)">mdi-arrow-up-bold</v-icon>
                        <v-icon v-if="(filter.sortDesc && filter.sortBy == 'createdAt')" @click="sortOptions(null, null)">mdi-arrow-down-bold</v-icon>
                    </v-btn>
                </template>
                <template v-slot:[`header.visitedAt`]="{header}">
                    {{ header.text }}
                    <v-btn icon x-small>
                        <v-icon v-if="(filter.sortBy == null || filter.sortBy !== 'visitedAt')" @click="sortOptions(`visitedAt`, false)">mdi-arrow-up-bold-outline</v-icon>
                        <v-icon v-if="(filter.sortDesc == false && filter.sortBy == 'visitedAt')"  @click="sortOptions(`visitedAt`, true)">mdi-arrow-up-bold</v-icon>
                        <v-icon v-if="(filter.sortDesc && filter.sortBy == 'visitedAt')" @click="sortOptions(null, null)">mdi-arrow-down-bold</v-icon>
                    </v-btn>
                </template>
                <template v-slot:[`header.withdrawnAt`]="{header}">
                    {{ header.text }}
                    <v-btn icon x-small>
                        <v-icon v-if="(filter.sortBy == null || filter.sortBy !== 'withdrawnAt')" @click="sortOptions(`withdrawnAt`, false)">mdi-arrow-up-bold-outline</v-icon>
                        <v-icon v-if="(filter.sortDesc == false && filter.sortBy == 'withdrawnAt')"  @click="sortOptions(`withdrawnAt`, true)">mdi-arrow-up-bold</v-icon>
                        <v-icon v-if="(filter.sortDesc && filter.sortBy == 'withdrawnAt')" @click="sortOptions(null, null)">mdi-arrow-down-bold</v-icon>
                    </v-btn>
                </template>
                <template #[`item.phone`]="{item}">{{ item?.phone?.phoneNumberFormat?.() ?? '-' }}</template>
                <template #[`item.point`]="{item}">{{ item?.point?.format?.() ?? '-' }}</template>
                <template #[`item.cash`]="{item}">{{ item?.cash?.format?.() ?? '-' }}</template>
                <template #[`item.isWithdrawal`]="{item}">
                    <v-switch v-model="item.isWithdrawal" :disabled="!$hasScope(['root', 'admin'])" hide-details class="pa-0 ma-0 d-inline-block" color="red lighten-2" @change="update({ _id: item._id, name: item.name, isWithdrawal: item.isWithdrawal })"/>
                </template>
                <template #[`item.createdAt`]="{item}">{{ $dayjs(item.createdAt).format("YYYY-MM-DD HH:mm:ss") }}</template>
                <template #[`item.visitedAt`]="{item}">{{ $dayjs(item.visitedAt).format("YYYY-MM-DD HH:mm:ss") }}</template>
                <template #[`item.withdrawnAt`]="{item}">{{ $dayjs(item.withdrawnAt).format("YYYY-MM-DD HH:mm:ss") }}</template>
                <template #[`item.withdrawnUntil`]="{item}">
                    <div class="mt-4">
                        <v-date-field v-model="item.withdrawnUntil" :disabled="!$hasScope(['root', 'admin'])" dense outlined @input="updateWithdrawn(item)"/>
                    </div>
                </template>
                <template #[`item.actions`]="{item}">
                    <v-icon small class="ml-3" @click="remove(item)">mdi-delete</v-icon>
                </template>
            </v-data-table>
    
            <v-pagination v-model="page" :length="pageCount" total-visible="11" class="my-4" @input="search(true)" />

        </console-body>

    </console-layout>
</template>

<script>
import api from "@/api";
import XLSX from "xlsx";
import { mdiMicrosoftExcel, mdiPlusCircleMultipleOutline } from "@mdi/js";
import VDateField from "@/components/plugins/vuetify/v-date-field.vue";
import ConsoleContent from "@/templates/console/ConsoleContent.vue";
import WithdrawalDialog from "@/components/console/user/withdrawal-dialog.vue";

export default {
    components: {
        ConsoleContent,
        VDateField,
        WithdrawalDialog
    },
    data(){
        return {
            mdiMicrosoftExcel,
            mdiPlusCircleMultipleOutline,

            showSearch: true,

            filter: {
                withdrawnAt: [ this.$route.query.withdrawnAt?.[0] || '', this.$route.query.withdrawnAt?.[1] || '' ],
                levelCode: this.$route.query.levelCode || null,
                isWithdrawal: true,
                searchKey: this.$route.query.searchKey || null,
                searchValue: this.$route.query.searchValue || null,
                sortBy: null,
                sortDesc: null
            },

            searchKeys: [
                { text: ":: 전체 ::", value: null },
                { text: "이름", value: "name" },
                { text: "아이디", value: "username" },
                { text: "연락처", value: "phone" },
                { text: "이메일", value: "email" },
            ],

            page: +this.$route.query.page || 1,
            pageCount: 0,
            limit: 10,
            loading: true,

            members: [],
            summary: { totalCount: 0 },
            membersHeaders: [
                { text: "아이디", value: "username", align: "center" },
                { text: "회원이름", value: "name", align: "center" },
                { text: "연락처", value: "phone", align: "center" },
                { text: "이메일", value: "email", align: "center" },
                { text: "포인트", value: "point", align: "center" },
                { text: "캐시", value: "cash", align: "center" },
                { text: "탈퇴", value: "isWithdrawal", align: "center"},
                { text: "가입일자", value: "createdAt", align: "center" },
                { text: "마지막 방문일자", value: "visitedAt", align: "center" },
                { text: "탈퇴일자", value: "withdrawnAt", align: "center" },
                { text: "재가입 유예기간", value: "withdrawnUntil", align: "center" },
                ...(this.$hasScope(['root', 'admin']) ? [{ text: "actions", value: "actions", align: "center"}] : []),
            ],

            giftcardLevels: [
                { text: ":: 전체 ::", value: null },
                { text: "normal", value: "normal" },
                { text: "vip", value: "vip" },
                { text: "vvip", value: "vvip" },
            ],
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        async init(){
            await this.search();
        },
        async search(routable = false){
            if(routable){
                this.$router.push({
                    query: { ...this.filter, page: this.page }
                });
            }

            this.loading = true;
            this.members = [];
            let { summary, members } = await api.console.members.gets({
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit
                },
                params: this.filter
            });

            this.loading = false;
            this.members = members;
            this.summary = summary;
            this.pageCount = Math.ceil(summary.totalCount / this.limit);
        },
        async update(member){
            if(confirm("'탈퇴 해제 시 계정이 복구 됩니다’\n진행 하시겠습니까?")){
                await api.console.members.put(member);
                await this.init();
                alert(`${member.name}님의 계정이 복구되었습니다.`)
            } else {
                await this.init();
            }
        },
        async updateWithdrawn(member){
            try{
                await api.console.members.put({ _id: member._id, withdrawnUntil: member.withdrawnUntil });
                await this.init();
            } catch(error) {
                alert(error);
            }
        },
        async remove(member){
            if(confirm("삭제 하시겠습니까?")){
                await api.console.members.delete(member);
                this.search();
            }
        },

        async excel(){

            var { members } = await api.console.members.gets({
                headers: {
                    limit: 0
                },
                params: this.filter
            });

            var rows = [];
            members.forEach(member => {
                rows.push({
                    "아이디": member.username,
                    "회원이름": member.name,
                    "연락처": member.phone,
                    "이메일": member.email,
                    "가입일자": member.createdAt ? this.$dayjs(member.createdAt).format("YYYY-MM-DD HH:mm:ss") : '-',
                    "탈퇴일자": member.withdrawnAt ? this.$dayjs(member.withdrawnAt).format("YYYY-MM-DD HH:mm:ss") : '-'
                });
            });

            var workbook = new XLSX.utils.book_new();
            var worksheet = XLSX.utils.json_to_sheet(rows);

            XLSX.utils.book_append_sheet(workbook, worksheet, "new");
            XLSX.writeFile(workbook, "탈퇴회원.xlsx");
        },
        async sortOptions(sortBy, sortDesc) {
            this.filter.sortBy = sortBy;
            this.filter.sortDesc = sortDesc;
            await this.init()
        }
    }
}
</script>